import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from '@/context/AuthContext';
import './App.css';

import Login from '@/pages/Login';
import Dashboard from '@/pages/Dashboard';
import Projects from '@/pages/Projects';
import ProjectDetail from '@/pages/ProjectDetail';
import MapView from '@/pages/MapView';
import TreeRegistration from '@/pages/TreeRegistration';
import MeasurementEntry from '@/pages/MeasurementEntry';
import HealthAssessment from '@/pages/HealthAssessment';
import AIAssistant from '@/pages/AIAssistant';
import SyncCenter from '@/pages/SyncCenter';
import Inspect from '@/pages/Inspect';
import TreeDetail from '@/pages/TreeDetail';

import BottomNav from '@/components/BottomNav';
import SyncBanner from '@/components/SyncBanner';
import PWAStatus from '@/components/PWAStatus';
import BrandFooter from '@/components/BrandFooter';

function RequireAuth() {
  const { user } = useAuth();
  const loc = useLocation();
  if (!user) return <Navigate to="/login" state={{ from: loc }} replace />;
  return <Outlet />;
}

function Shell() {
  return (
    <div className="min-h-screen bg-canvas pb-[112px] max-w-md mx-auto relative">
      <PWAStatus />
      <SyncBanner />
      <Outlet />
      <div className="fixed bottom-[56px] left-1/2 -translate-x-1/2 w-full max-w-md z-30">
        <BrandFooter />
      </div>
      <BottomNav />
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<RequireAuth />}>
            <Route element={<Shell />}>
              <Route index element={<Dashboard />} />
              <Route path="projects" element={<Projects />} />
              <Route path="projects/:projectId" element={<ProjectDetail />} />
              <Route path="map" element={<MapView />} />
              <Route path="inspect" element={<Inspect />} />
              <Route path="trees/new" element={<TreeRegistration />} />
              <Route path="trees/:treeId" element={<TreeDetail />} />
              <Route path="trees/:treeId/measure" element={<MeasurementEntry />} />
              <Route path="trees/:treeId/health" element={<HealthAssessment />} />
              <Route path="assistant" element={<AIAssistant />} />
              <Route path="sync" element={<SyncCenter />} />
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
